import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia } from '@mui/material';
import SEO from '../components/SEO';

const Services = () => {
  const services = [
    {
      title: "Regular Classes",
      description: "Comprehensive classroom teaching with regular assessments and doubt clearing sessions.",
      image: "/book.png"
    },
    {
      title: "Online Classes",
      description: "Live interactive online sessions with recorded lectures for revision.",
      image: "/book.png"
    },
    {
      title: "Test Series",
      description: "Regular mock tests and practice papers to prepare for competitive exams.",
      image: "/book.png"
    },
    {
      title: "Doubt Clearing",
      description: "One-on-one doubt clearing sessions with subject experts.",
      image: "/book.png"
    },
    {
      title: "Study Material",
      description: "Comprehensive study material and notes prepared by expert faculty.",
      image: "/book.png"
    },
    {
      title: "Career Counseling",
      description: "Expert guidance for career choices and college admissions.",
      image: "/book.png"
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO 
        title="Our Educational Services - SOLID CLASSES"
        description="Explore our comprehensive educational services including regular classes, online classes, test series, doubt clearing sessions, study material, and career counseling at SOLID CLASSES."
        keywords="SOLID CLASSES services, online classes, test series, doubt clearing, study material, career counseling, NEET JEE coaching, best coaching in Jodhpur"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Our Services
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Comprehensive educational services to help you achieve your goals
      </Typography>

      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardMedia
                component="img"
                height="200"
                image={service.image}
                alt={service.title}
                sx={{ objectFit: 'contain', backgroundColor: 'transparent' }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {service.title}
                </Typography>
                <Typography>
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Services; 
